import type { ChangeEvent } from 'react';
import { useConfig } from 'shared/config/ConfigContext';
import type { ApiQueryParams } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';

export interface OriginDropdownProps {
    selectedValue: string;
    hideLabel?: boolean;
    triggerFetch: (apiUrl: string, queryParam?: ApiQueryParams) => void;
    filterChange: (newOriginAirportValue: string) => void;
}

interface Origin {
    value: string;
    text: string;
}

export const OriginDropdown = ({ selectedValue, hideLabel = false, filterChange, triggerFetch }: OriginDropdownProps) => {
    const { apiUrl } = useConfig();
    const onChange = (event: ChangeEvent<HTMLSelectElement>): void => {
        filterChange(event.target.value);
        triggerFetch(apiUrl);
    };

    return (
        <div className="input input--select u-mt16">
            <label htmlFor="fromAirport" className={hideLabel ? 'u-screen-reader-only' : ''}>
                Reis fra
            </label>
            <div className="input--select__wrap">
                <select
                    value={selectedValue}
                    onChange={onChange}
                    id="origin"
                    aria-label="Avreisested"
                    onBlur={(): undefined => undefined}
                    data-testid="originDropdown">
                    {displayValues.originAirports.map((origin: Origin) => (
                        <option key={origin.value} value={origin.value}>
                            {origin.text}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};
